import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/user/services';
import { ViewWillLeave } from '@ionic/angular';
import { PanAppState } from '@panamax/app-state';
import { FEATURES } from '@shared/constants/splitio-features';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-compare',
  templateUrl: './product-compare.page.html',
  styleUrls: ['./product-compare.page.scss'],
})
export class ProductComparePage implements OnInit, ViewWillLeave {
  constructor(
    readonly panAppState: PanAppState,
    private userService: UserService,
  ) {}

  shouldConvertToPopover = false;
  POPOVER_TARGER_DEPTH = 30;
  CARD_TARGET_DEPTH = 15;
  targetPercent: number = this.CARD_TARGET_DEPTH;
  popoverFeatureFlag: boolean;
  isGuestUser$: Observable<boolean>;
  popoverFeatureFlag$: Subscription;

  ngOnInit() {
    this.isGuestUser$ = this.userService.isGuestUser$();
    this.popoverFeatureFlag$ = this.panAppState
      .feature$([FEATURES.split_global_product_compare_popover.name])
      .subscribe(featureFlag => {
        if (featureFlag) {
          this.popoverFeatureFlag = featureFlag;
        }
      });
  }

  ionViewWillLeave(): void {
    if (this.popoverFeatureFlag$) {
      this.popoverFeatureFlag$.unsubscribe();
    }
  }

  async handleScroll($event) {
    // if feature flag is OFF, just skip this calculation and make sure popover bool is FALSE
    if (!this.popoverFeatureFlag) {
      this.shouldConvertToPopover = false;
      return;
    }

    const scrollElement = await $event.target.getScrollElement();
    const scrollHeight =
      scrollElement.scrollHeight - scrollElement.clientHeight;

    const currentScrollDepth = scrollElement.scrollTop;

    let triggerDepth = (scrollHeight / 100) * this.targetPercent;

    if (currentScrollDepth > triggerDepth) {
      this.shouldConvertToPopover = true;
      this.targetPercent = this.CARD_TARGET_DEPTH;
    } else {
      this.shouldConvertToPopover = false;
      this.targetPercent = this.POPOVER_TARGER_DEPTH;
    }
  }
}
